var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 1.25V14.7505M1.25 2.15003H14.3005C14.3872 2.15012 14.472 2.17526 14.5447 2.22241C14.6175 2.26956 14.6751 2.33672 14.7106 2.41581C14.7461 2.49491 14.7579 2.58258 14.7448 2.66827C14.7317 2.75396 14.694 2.83403 14.6365 2.89886L12.2334 5.60015C12.0868 5.76494 12.0058 5.97782 12.0058 6.19838C12.0058 6.41893 12.0868 6.63181 12.2334 6.7966L14.6335 9.49969C14.691 9.56452 14.7287 9.64459 14.7418 9.73028C14.7549 9.81597 14.7431 9.90364 14.7076 9.98274C14.6721 10.0618 14.6145 10.129 14.5417 10.1761C14.469 10.2233 14.3842 10.2484 14.2975 10.2485H1.25",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.a118c7a3009dbaf3a33f632f47442da6.svg";
export { ForwardRef as ReactComponent };